import React,{useEffect} from 'react';
import styled from 'styled-components';
import { AppState } from '../../store';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import Link from '../elements/link';
import { Card, CardActionButton, TableNew } from '../elements';
import { CONSTS } from '../elements/_constants';
import { fetchUsers } from '../../store/base/functions';
type UsersListComponentProps = {
    className?: string,
    match: any,
    onFetchUsers: Function,
    users: any,
}
const UsersListComponent = (props: UsersListComponentProps) => {
    useEffect(() => {
      try {
        props.onFetchUsers(); 
      } catch (error) {
        console.log(error);
      }
      return () => {};
    }, [])
    const columns :any[] = [
        {
            title: "نام",
            dataIndex: "first_name"
        },
        {
            title: "نام خانوادگی",
            dataIndex : "last_name"
        },
        {
            title: "تلفن همراه",
            dataIndex: "phone"
        },
        {
            title: "ایمیل",
            dataIndex: "email"
        },
        {
          title: '',
          dataIndex: 'id',
          style: {width: 50},
          render: (id:number) => (
            <Link style={{color:CONSTS.colors.greyDarker}} to={`/users/${id}`}>ویرایش</Link>
          )
        }
    ];

    return (
        <div className={props.className}>
          <Card
              title={"لیست کاربران"}
              headerMeta={<>
                <CardActionButton title="ایجاد کاربر جدید" to={`/users/new`} iconClassName="icon-icons8-plus_math" hasBorderRight={true}/>
              </>}
            >
              <div style={{padding: 25}}>
              {props.users && <TableNew dataSource={props.users} columns={columns} />}
              </div>
            </Card>
        </div>
    )
}
const UsersList = styled(UsersListComponent)`
  /* padding-left: 29px; */
  @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
    padding-left: 15px;
  }
`

const mapStateToProps = (state: AppState,ownProps: any) => ({
  users: state.base.users,
});

const mapDispatchToProps = (dispatch:any) => {
    return {
      onFetchUsers    : ()  =>{
        dispatch(fetchUsers());
      }
    };
  };
  
  export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
  )(UsersList));
